var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { ref: "mediapicker", staticClass: "modal modal-panel fade" },
    [
      _c("div", { staticClass: "modal-dialog modal-lg" }, [
        _c("div", { staticClass: "modal-content" }, [
          _c("div", { staticClass: "modal-header" }, [
            _c("h5", { staticClass: "modal-title" }, [
              _c("i", { staticClass: "fas fa-images" }),
              _vm._v(" " + _vm._s(_vm.$t("mediaSelectMedia")))
            ]),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "close",
                attrs: { type: "button", "aria-label": "Close" },
                on: {
                  click: function($event) {
                    return _vm.closeModal()
                  }
                }
              },
              [_c("span", { attrs: { "aria-hidden": "true" } }, [_vm._v("×")])]
            )
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "modal-body bg-light" },
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col" }, [
                  _c("ul", { staticClass: "nav nav-pills mb-3" }, [
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link",
                          class: { active: _vm.listView },
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.toggle.apply(null, arguments)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-list" })]
                      )
                    ]),
                    _vm._v(" "),
                    _c("li", { staticClass: "nav-item" }, [
                      _c(
                        "a",
                        {
                          staticClass: "nav-link",
                          class: { active: !_vm.listView },
                          attrs: { href: "#" },
                          on: {
                            click: function($event) {
                              $event.preventDefault()
                              return _vm.toggle.apply(null, arguments)
                            }
                          }
                        },
                        [_c("i", { staticClass: "fas fa-table" })]
                      )
                    ])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col" }, [
                  _c(
                    "div",
                    { staticClass: "d-flex flex-row" },
                    [
                      _vm.canMediaAddFolder
                        ? [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.folderName,
                                  expression: "folderName"
                                }
                              ],
                              staticClass: "form-control flex-fill",
                              attrs: {
                                type: "text",
                                placeholder: _vm.$t("mediaAddFolder")
                              },
                              domProps: { value: _vm.folderName },
                              on: {
                                keyup: function($event) {
                                  if (
                                    !$event.type.indexOf("key") &&
                                    _vm._k(
                                      $event.keyCode,
                                      "enter",
                                      13,
                                      $event.key,
                                      "Enter"
                                    )
                                  )
                                    return null
                                  return _vm.saveFolder.apply(null, arguments)
                                },
                                input: function($event) {
                                  if ($event.target.composing) return
                                  _vm.folderName = $event.target.value
                                }
                              }
                            }),
                            _vm._v(" "),
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary ml-3",
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.saveFolder.apply(null, arguments)
                                  }
                                }
                              },
                              [_c("i", { staticClass: "fas fa-plus" })]
                            )
                          ]
                        : _vm._e()
                    ],
                    2
                  )
                ])
              ]),
              _vm._v(" "),
              _vm.canMediaAdd
                ? _c("DropZone", {
                    attrs: { formId: "mediapickerdz" + _vm._uid },
                    on: {
                      complete: _vm.onDzComplete,
                      "queue-complete": _vm.onDzQueueComplete
                    }
                  })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "form-group mt-3" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.search,
                      expression: "search"
                    }
                  ],
                  ref: "mediapickerSearch",
                  staticClass: "form-control",
                  attrs: { placeholder: _vm.$t("txtSearch") },
                  domProps: { value: _vm.search },
                  on: {
                    keyup: function($event) {
                      if (
                        !$event.type.indexOf("key") &&
                        _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                      )
                        return null
                      return _vm.onEnter.apply(null, arguments)
                    },
                    input: function($event) {
                      if ($event.target.composing) return
                      _vm.search = $event.target.value
                    }
                  }
                })
              ]),
              _vm._v(" "),
              _vm.listView
                ? [
                    _c(
                      "table",
                      { staticClass: "table table-borderless table-media" },
                      [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v(_vm._s(_vm.$t("txtFileName")))]),
                            _vm._v(" "),
                            _c("th", { staticClass: "td-medium d-none" }, [
                              _vm._v(_vm._s(_vm.$t("txtFileType")))
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "td-small d-none" }, [
                              _vm._v(_vm._s(_vm.$t("txtFileSize")))
                            ]),
                            _vm._v(" "),
                            _c("th", { staticClass: "td-small" }, [
                              _vm._v(_vm._s(_vm.$t("txtFileModified")))
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          [
                            _vm.currentFolderId != null
                              ? _c("tr", [
                                  _c("td", [
                                    _c(
                                      "a",
                                      {
                                        attrs: { href: "#" },
                                        on: {
                                          click: function($event) {
                                            $event.preventDefault()
                                            return _vm.load(_vm.parentFolderId)
                                          }
                                        }
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "fas fa-folder-open"
                                        }),
                                        _vm._v("...\n                  ")
                                      ]
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "d-none" }),
                                  _vm._v(" "),
                                  _c("td", { staticClass: "d-none" }),
                                  _vm._v(" "),
                                  _c("td")
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm._l(_vm.filteredFolders, function(folder) {
                              return _c("tr", [
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.load(folder.id)
                                        }
                                      }
                                    },
                                    [
                                      _c("i", {
                                        staticClass: "fas fa-folder-open"
                                      }),
                                      _vm._v(
                                        _vm._s(folder.name) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "d-none" }),
                                _vm._v(" "),
                                _c("td", { staticClass: "d-none" }),
                                _vm._v(" "),
                                _c("td")
                              ])
                            }),
                            _vm._v(" "),
                            _vm._l(_vm.filteredItems, function(item) {
                              return _c("tr", [
                                _c("td", [
                                  _c(
                                    "a",
                                    {
                                      attrs: { href: "#" },
                                      on: {
                                        click: function($event) {
                                          $event.preventDefault()
                                          return _vm.select(item)
                                        }
                                      }
                                    },
                                    [
                                      item.type === "Audio"
                                        ? _c("i", {
                                            staticClass: "fas fa-volume-up"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === "Document"
                                        ? _c("i", {
                                            staticClass: "fas fa-file-alt"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === "Image"
                                        ? _c("i", {
                                            staticClass: "fas fa-image"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === "Video"
                                        ? _c("i", {
                                            staticClass: "fas fa-video"
                                          })
                                        : _vm._e(),
                                      _vm._v(" "),
                                      item.type === "Resource"
                                        ? _c("i", {
                                            staticClass: "fas fa-box-open"
                                          })
                                        : _vm._e(),
                                      _vm._v(
                                        "\n                    " +
                                          _vm._s(item.filename) +
                                          "\n                  "
                                      )
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "d-none" }, [
                                  _vm._v(_vm._s(item.contentType))
                                ]),
                                _vm._v(" "),
                                _c("td", { staticClass: "d-none" }, [
                                  _vm._v(_vm._s(item.sizePrettyPrint))
                                ]),
                                _vm._v(" "),
                                _c("td", [_vm._v(_vm._s(item.lastModified))])
                              ])
                            })
                          ],
                          2
                        )
                      ]
                    )
                  ]
                : _vm._e(),
              _vm._v(" "),
              !_vm.listView
                ? [
                    _c(
                      "div",
                      { staticClass: "gallery gallery-sm" },
                      [
                        _c("div", { staticClass: "gallery-header" }, [
                          _vm._v(
                            "\n              " +
                              _vm._s(_vm.$t("mediaGallery")) +
                              "\n            "
                          )
                        ]),
                        _vm._v(" "),
                        _vm.currentFolderId != null
                          ? _c(
                              "a",
                              {
                                staticClass: "thumbnail",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.load(_vm.parentFolderId)
                                  }
                                }
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src:
                                      "manager/assets/img/media-placeholder.png"
                                  }
                                }),
                                _vm._v(" "),
                                _vm._m(0),
                                _vm._v(" "),
                                _c("p", { staticClass: "thumbnail-text" }, [
                                  _vm._v("...")
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._l(_vm.filteredFolders, function(folder) {
                          return _c(
                            "a",
                            {
                              staticClass: "thumbnail",
                              attrs: { href: "#" },
                              on: {
                                click: function($event) {
                                  $event.preventDefault()
                                  return _vm.load(folder.id)
                                }
                              }
                            },
                            [
                              _c("img", {
                                attrs: {
                                  src:
                                    "manager/assets/img/media-placeholder.png"
                                }
                              }),
                              _vm._v(" "),
                              _vm._m(1, true),
                              _vm._v(" "),
                              _c("p", { staticClass: "thumbnail-text" }, [
                                _vm._v(_vm._s(folder.name))
                              ])
                            ]
                          )
                        }),
                        _vm._v(" "),
                        _vm._l(_vm.filteredItems, function(item) {
                          return [
                            _c(
                              "a",
                              {
                                staticClass: "thumbnail",
                                attrs: { href: "#" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.select(item)
                                  }
                                }
                              },
                              [
                                item.type === "Image"
                                  ? [
                                      _c("img", {
                                        staticClass: "thumbnail-image mw-100",
                                        attrs: {
                                          src: _vm.getThumbnailUrl(item)
                                        }
                                      })
                                    ]
                                  : item.type === "Document"
                                  ? [_vm._m(2, true)]
                                  : item.type === "Video"
                                  ? [_vm._m(3, true)]
                                  : item.type === "Resource"
                                  ? [_vm._m(4, true)]
                                  : [_vm._m(5, true)],
                                _vm._v(" "),
                                _c("p", { staticClass: "thumbnail-text" }, [
                                  _vm._v(_vm._s(item.filename))
                                ])
                              ],
                              2
                            )
                          ]
                        })
                      ],
                      2
                    )
                  ]
                : _vm._e()
            ],
            2
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = [
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "thumbnail-icon" }, [
      _c("i", { staticClass: "fas fa-folder-open fa-3x" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "thumbnail-icon" }, [
      _c("i", { staticClass: "fas fa-folder fa-3x" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "thumbnail-icon" }, [
      _c("i", { staticClass: "fas fa-file-alt fa-3x" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "thumbnail-icon" }, [
      _c("i", { staticClass: "fas fa-film fa-3x" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "thumbnail-icon" }, [
      _c("i", { staticClass: "fas fa-box-open fa-3x" })
    ])
  },
  function() {
    var _vm = this,
      _c = _vm._self._c,
      _setup = _vm._self._setupProxy
    return _c("div", { staticClass: "thumbnail-icon" }, [
      _c("i", { staticClass: "fas fa-file" }),
      _vm._v(" "),
      _c("i", { staticClass: "fas fa-file fa-3x" })
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }